"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GeneralLogoutHandler {
    constructor(sessionInfoManager) {
        this.sessionInfoManager = sessionInfoManager;
    }
    async canHandle() {
        return true;
    }
    async handle(userId) {
        await this.sessionInfoManager.clear(userId);
    }
}
exports.default = GeneralLogoutHandler;
//# sourceMappingURL=GeneralLogoutHandler.js.map